let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e8XrO")).then(() => parcelRequire('bgpcC'));